import './AdmissionSkeleton.css';

const AdmissionSkeleton = () => {
    return (
        <div className="admission-skeleton">
            {/* Patient Identity Header Skeleton */}
            <div className="admission-skeleton-header">
                <div className="admission-skeleton-header-left">
                    <div className="admission-skeleton-identity-badge">
                        <div className="admission-skeleton-block admission-skeleton-identity-text" />
                        <div className="admission-skeleton-block admission-skeleton-verified-badge" />
                    </div>
                    <div className="admission-skeleton-block admission-skeleton-patient-name" />
                    <div className="admission-skeleton-meta">
                        <div className="admission-skeleton-block admission-skeleton-meta-item" />
                        <div className="admission-skeleton-block admission-skeleton-meta-item" />
                        <div className="admission-skeleton-block admission-skeleton-meta-item" />
                    </div>
                </div>
                <div className="admission-skeleton-header-right">
                    <div className="admission-skeleton-block admission-skeleton-status-badge" />
                </div>
            </div>

            {/* Main Content Skeleton */}
            <div className="admission-skeleton-content">
                {/* Left Column */}
                <div className="admission-skeleton-content-left">
                    {/* Patient Profile Summary Skeleton */}
                    <div className="admission-skeleton-card">
                        <div className="admission-skeleton-block admission-skeleton-card-title" />
                        
                        <div className="admission-skeleton-section-card">
                            <div className="admission-skeleton-block admission-skeleton-section-title" />
                            <div className="admission-skeleton-block admission-skeleton-text-line" />
                            <div className="admission-skeleton-block admission-skeleton-text-line short" />
                        </div>

                        <div className="admission-skeleton-info-grid">
                            <div className="admission-skeleton-info-item">
                                <div className="admission-skeleton-block admission-skeleton-label" />
                                <div className="admission-skeleton-block admission-skeleton-value" />
                            </div>
                            <div className="admission-skeleton-info-item">
                                <div className="admission-skeleton-block admission-skeleton-label" />
                                <div className="admission-skeleton-block admission-skeleton-value" />
                            </div>
                            <div className="admission-skeleton-info-item">
                                <div className="admission-skeleton-block admission-skeleton-label" />
                                <div className="admission-skeleton-block admission-skeleton-value" />
                            </div>
                        </div>

                        <div className="admission-skeleton-section-card">
                            <div className="admission-skeleton-block admission-skeleton-section-title" />
                            <div className="admission-skeleton-block admission-skeleton-text-line" />
                            <div className="admission-skeleton-block admission-skeleton-text-line" />
                            <div className="admission-skeleton-block admission-skeleton-text-line short" />
                        </div>
                    </div>

                    {/* Quotation Summary Skeleton */}
                    <div className="admission-skeleton-card">
                        <div className="admission-skeleton-block admission-skeleton-card-title" />
                        
                        <div className="admission-skeleton-summary-card-item">
                            <div className="admission-skeleton-block admission-skeleton-label" />
                             <br />
                            <div className="admission-skeleton-block admission-skeleton-value" />
                        </div>

                        <div className="admission-skeleton-packages">
                            <div className="admission-skeleton-package-card">
                                <div className="admission-skeleton-block admission-skeleton-label" />
                                <div className="admission-skeleton-package-list">
                                    <div className="admission-skeleton-package-item">
                                        <div className="admission-skeleton-block admission-skeleton-package-name" />
                                        <div className="admission-skeleton-block admission-skeleton-package-price" />
                                    </div>
                                    <div className="admission-skeleton-package-item">
                                        <div className="admission-skeleton-block admission-skeleton-package-name" />
                                        <div className="admission-skeleton-block admission-skeleton-package-price" />
                                    </div>
                                    <div className="admission-skeleton-package-item">
                                        <div className="admission-skeleton-block admission-skeleton-package-name" />
                                        <div className="admission-skeleton-block admission-skeleton-package-price" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="admission-skeleton-total">
                            <div className="admission-skeleton-block admission-skeleton-total-label" />
                            <div className="admission-skeleton-block admission-skeleton-total-value" />
                        </div>
                    </div>
                </div>

                {/* Right Column */}
                <div className="admission-skeleton-content-right">
                    {/* Medical Documents Skeleton */}
                    <div className="admission-skeleton-card">
                        <div className="admission-skeleton-block admission-skeleton-card-title" />
                        <div className="admission-skeleton-documents">
                            <div className="admission-skeleton-block admission-skeleton-document-item" />
                            <div className="admission-skeleton-block admission-skeleton-document-item" />
                            <div className="admission-skeleton-block admission-skeleton-document-item" />
                        </div>
                    </div>

                    {/* Final Confirmation Skeleton */}
                    <div className="admission-skeleton-card">
                        <div className="admission-skeleton-block admission-skeleton-card-title" />
                        <div className="admission-skeleton-block admission-skeleton-text-line" />
                        <div className="admission-skeleton-block admission-skeleton-text-line short" />
                    </div>
                </div>
            </div>

            {/* Footer Skeleton */}
            <div className="admission-skeleton-footer">
                <div className="admission-skeleton-block admission-skeleton-back-btn" />
                <div className="admission-skeleton-footer-right">
                    <div className="admission-skeleton-time-container">
                        <div className="admission-skeleton-block admission-skeleton-time-label" />
                        <div className="admission-skeleton-block admission-skeleton-time-value" />
                    </div>
                    <div className="admission-skeleton-block admission-skeleton-submit-btn" />
                </div>
            </div>
        </div>
    );
};

export default AdmissionSkeleton;
